/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Select from "react-dropdown";
import { useAddFaq, useUpdateFaq } from "../../../queryHooks";
import CS from "../../../services/commonService";
import { useFormik } from "formik";
import { addFaqQuerySchema } from "../../../validations";
import { useStore } from "../../../zustand/store";
//  Component starts
const AddUpdate = ({ category, onCloseModal, faqCategories }) => {
	//	Pre-defined values

	const statusOptions = [
		{ value: 1, label: "Active" },
		{ value: 0, label: "Inactive" },
	];
	const [form] = useState({
		category_id: category.category_id,
		question: category.question,
		answer: category.answer,
	});
	const setLoading = useStore((state) => state.setLoading);
	const [status, setCategory] = useState(
		statusOptions.find((option) => option.value === category.is_active) || {
			value: 1,
			label: "Active",
		}
	);

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: form,
		validationSchema: addFaqQuerySchema,
		onSubmit: async (values) => {
			if (category.id) {
				updateFaqCategory({
					id: category.id,
					question: values.question,
					answer: values.answer,
					is_active: status.value,
					category_id: values.category_id,
				});
				setLoading(true);
			} else {
				addFaq(values);
				setLoading(true);
			}
		},
	});

	const {
		mutateAsync: addFaq,
		error: errorAddFaq,
		data: dataAddFaq,
	} = useAddFaq();

	useEffect(() => {
		if (dataAddFaq) {
			setLoading(false);
			if (dataAddFaq.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataAddFaq.message);
			} else if (dataAddFaq.status === "fail") {
				CS.showErrorMessage(dataAddFaq.message);
			}
		}
	}, [dataAddFaq]);

	useEffect(() => {
		if (errorAddFaq) {
			setLoading(false);
			CS.showErrorMessage(errorAddFaq.response?.data?.message);
		}
	}, [errorAddFaq]);

	const {
		mutateAsync: updateFaqCategory,
		error: errorUpdateFaq,
		data: dataUpdateFaq,
	} = useUpdateFaq();

	useEffect(() => {
		if (dataUpdateFaq) {
			setLoading(false);
			if (dataUpdateFaq.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataUpdateFaq.message);
			} else if (dataUpdateFaq.status === "fail") {
				CS.showErrorMessage(dataUpdateFaq.message);
			}
		}
	}, [dataUpdateFaq]);

	useEffect(() => {
		if (errorUpdateFaq) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateFaq.response?.data?.message);
		}
	}, [errorUpdateFaq]);

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">
					{category.id ? "Update FAQ" : "Add FAQ"}
				</h5>
			</div>
			<div className="notification-form modal-body card profile-card password-modal">
				<div className="row">
					<div className="col-md-12">
						<form onSubmit={handleSubmit}>
							<div className="mb-md-4 mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label" htmlFor="title">
										Category<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<Select
											value={category.category_name || faqCategories.label}
											onChange={(option) =>
												handleChange({
													target: {
														id: "category_id",
														value: option.value,
													},
												})
											}
											placeholder="Select category"
											options={faqCategories}
											id="category_id"
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.category_id && touched.category_id
													? errors.category_id
													: null}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div className="mb-md-4 mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label" htmlFor="title">
										Question<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type="text"
											id="question"
											name="question"
											placeholder="Enter question"
											value={values.question}
											onChange={handleChange}
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.question && touched.question
													? errors.question
													: null}
											</span>
										</div>
									</div>
								</div>
								<div className="form-group mb-0">
									<label className="label xl-label" htmlFor="title">
										Answer<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<textarea
											rows="6"
											className="form-control"
											placeholder="Enter answer"
											name="answer"
											id="answer"
											value={values.answer}
											onChange={handleChange}
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.answer && touched.answer ? errors.answer : null}
											</span>
										</div>
									</div>
								</div>
							</div>
							{category.id && (
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Status<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<Select
												value={status}
												onChange={(option) => setCategory(option)}
												options={statusOptions}
											/>
										</div>
									</div>
								</div>
							)}
							<div className="mt-5 text-right">
								<button className="btn btn-primary" type="submit">
									{category.id ? "Update" : "Add"}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUpdate;
